import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={0.5} width={35} height={23} fill="white" />
      <rect x={0.5} y={0.5} width={35} height={23} stroke="#E2E8F0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.78516 5.09766H18.3518C24.173 5.09766 26.41 8.27861 26.41 12.2993C26.41 17.1089 23.2833 19.5264 18.3518 19.5264H9.78516V5.09766ZM10.5985 5.96287V18.7121H18.3517C23.029 18.7121 25.5711 16.5236 25.5711 12.3248C25.5711 7.99868 22.8257 5.96287 18.3517 5.96287H10.5985ZM12.8864 12.5541C13.7428 12.5541 14.437 11.8591 14.437 11.0017C14.437 10.1442 13.7428 9.44917 12.8864 9.44917C12.03 9.44917 11.3358 10.1442 11.3358 11.0017C11.3358 11.8591 12.03 12.5541 12.8864 12.5541ZM11.6409 13.2154H14.1321V17.6438H11.6409V13.2154Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7493 9.57618H23.4611V11.7138H24.5033C24.2237 7.8203 21.1478 6.95508 18.3516 6.95508H15.3774V9.57618H15.8096C16.623 9.57618 17.106 10.1106 17.106 11.0012C17.106 11.8919 16.623 12.4263 15.835 12.4263H15.3774V17.6431H18.3516C22.9018 17.6431 24.4525 15.5309 24.5287 12.4263H22.7493V9.57618ZM19.3176 11.714V12.4266H17.5382V9.57618H19.2667V10.2888H18.2499V10.6197H19.2159V11.3323H18.2753V11.714H19.3176ZM19.6226 12.4266L20.4868 9.57618H21.5037L22.3679 12.4266H21.6308L21.4782 11.8922H20.5377L20.3852 12.4266H19.6226ZM20.749 11.154H20.7411V11.1795L20.749 11.154ZM20.749 11.154H21.2495L21.0207 10.3651H20.9953L20.749 11.154ZM15.3774 11.7139V10.2887H15.8096C16.0892 10.2887 16.3943 10.3651 16.3943 11.0013C16.3943 11.6376 16.1146 11.7139 15.8096 11.7139H15.3774Z"
        fill="#D50072"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-ideal" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
